import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBrandingDto } from './branding.dto';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BrandingService {

  constructor(private http: HttpClient) { }

  /**
   * Get branding data
   * @returns response
   */
  getBrandingData() {
    return this.http.get<IBrandingDto>('brands');
  }


  /**
   * Create and update branding data
   * @param formData 
   * @returns response
   */
  createBrandingData(formData: IBrandingDto) {
    return this.http.post('brands', formData);
  }

  /**
   * Constructs the full URL for a branding image based on the provided path.
   *
   * @param path - The relative path to the branding image.
   * @returns The full URL to the branding image.
   */
  getBrandingImagesPath(path: string, id:number): string {
    return `${environment.apiUrl}brands/${id}/image?path=${path}`;
  }
}
